import type { MarketSeriesData } from '../../../api/marketPricesClient';
import type { ChartSeries } from '../seriesTypes';

export function volumeSeries(
    data: readonly MarketSeriesData[],
    color: string
): ChartSeries {
    const byTime = new Map<number, number>();
    for (const market of data) {
        for (const candle of market.data) {
            const t = candle.t.getTime();
            byTime.set(t, (byTime.get(t) ?? 0) + (candle.vol || 0));
        }
    }
    const points = [...byTime.entries()]
        .map(([t, v]) => ({ t, v }))
        .sort((a, b) => a.t - b.t);
    return {
        id: 'volume',
        label: 'Volume',
        color,
        unit: 'usd',
        draw: 'bars',
        axis: 'hidden',
        home: 'probability',
        movable: false,
        hasData: points.some(p => p.v > 0),
        data: { kind: 'points', points },
    };
}
